import { Link } from "react-router-dom";

const categories = [
  { name: "热血", icon: "ri-fire-line", color: "text-primary-600 bg-primary-100" },
  { name: "奇幻", icon: "ri-sparkling-2-line", color: "text-accent-600 bg-accent-100" },
  { name: "恋爱", icon: "ri-heart-3-line", color: "text-primary-600 bg-primary-100" },
  { name: "科幻", icon: "ri-rocket-2-line", color: "text-secondary-700 bg-secondary-100" },
  { name: "日常", icon: "ri-home-4-line", color: "text-secondary-700 bg-secondary-100" },
  { name: "悬疑", icon: "ri-search-eye-line", color: "text-accent-600 bg-accent-100" },
  { name: "治愈", icon: "ri-mental-health-line", color: "text-secondary-700 bg-secondary-100" },
  { name: "神作", icon: "ri-trophy-line", color: "text-primary-600 bg-primary-100" },
];

export default function Categories() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-accent-600">
            <i className="ri-layout-grid-fill"></i> Browse by Tag
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">分类导航</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            从热门标签出发，直达你钟爱的动漫类型，越逛越上头。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {categories.map((c) => (
            <Link
              key={c.name}
              to={`/sousuo?tag=${encodeURIComponent(c.name)}`}
              className="group flex items-center gap-3 rounded-lg bg-background-50 p-4 transition-transform hover:-translate-y-1"
            >
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${c.color}`}>
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <div>
                <p className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600">
                  {c.name}
                </p>
                <p className="text-xs text-foreground-500">按标签检索</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}